import AssumptionsPage from './AssumptionsPage';

export default AssumptionsPage;
